import { all } from 'redux-saga/effects';
import authSaga from './auth.saga';
import ssoSaga from './sso.saga';
import {
  getAgendaRequest,
  setCompletadoEventoRequest,
  deleteEventRequest,
  createEventRequest,
  updateEventRequest,
} from './agenda/agenda.saga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    ssoSaga(),
    getAgendaRequest(),
    setCompletadoEventoRequest(),
    deleteEventRequest(),
    createEventRequest(),
    updateEventRequest(),

  ]);
}
